import {
  REGIONS_MUNICIPALITIES_FEATURES,
  type RegionsMunicipalitiesFeatures,
} from '@schema/featureToggle'
import { regionsTabs } from './constants'

const regionPageTabValues = new Set<string>(
  Object.values(REGIONS_MUNICIPALITIES_FEATURES),
)

/** Schema tab keys mapped to localized URL path segments */
const regionPageTabUrlSegmentByTab: Partial<
  Record<RegionsMunicipalitiesFeatures, string>
> = {
  [regionsTabs.current]: 'actueel',
  [regionsTabs.discussion]: 'discussie',
  [regionsTabs.initiatives]: 'initiatieven',
  [regionsTabs.municipalities]: 'gemeenten',
  [regionsTabs.locations]: 'locaties',
  [regionsTabs.knowledgeHub]: 'kennishub',
  [regionsTabs.developmentAreas]: 'ontwikkelgebieden',
  [regionsTabs.stepByStep]: 'stappenplan',
}

const regionPageTabByUrlSegment = Object.fromEntries(
  Object.entries(regionPageTabUrlSegmentByTab).map(([tab, segment]) => [
    segment,
    tab,
  ]),
) as Record<string, RegionsMunicipalitiesFeatures>

export const regionPageTabToUrlSegment = (
  tab: RegionsMunicipalitiesFeatures,
): string => regionPageTabUrlSegmentByTab[tab] ?? tab

export const parseRegionPageTab = (
  tab: string | undefined | null,
): RegionsMunicipalitiesFeatures => {
  if (tab && regionPageTabByUrlSegment[tab]) {
    return regionPageTabByUrlSegment[tab]
  }
  if (tab && regionPageTabValues.has(tab)) {
    return tab as RegionsMunicipalitiesFeatures
  }
  return REGIONS_MUNICIPALITIES_FEATURES.overview
}

export const isRegionPageTab = (
  tab: string,
): tab is RegionsMunicipalitiesFeatures =>
  regionPageTabValues.has(tab) || tab in regionPageTabByUrlSegment
